import type { SurveysEnumsRespondentStrategyEnum } from 'generated/resources/datatable.graphql'

type RespondentStrategy = {
  strategy: SurveysEnumsRespondentStrategyEnum
  arguments?: number[] | null
}

export function validRespondentStrategy(respondentStrategy: RespondentStrategy) {
  if (['all_employees', 'everyone', 'managers'].includes(respondentStrategy.strategy)) {
    return true
  }

  return Number(respondentStrategy.arguments?.length) > 0
}
